<template>
  <div
    class="tab full-height ma-auto mr-0 justify-space-evenly pb-sm-4 pt-sm-6"
    style="max-width: 120px"
  >
    <div class="dot-container" :class="{ 'scale-8': $vuetify.breakpoint.xs }">
      <div class="dot">
        <span class="rewards-points">
          {{ total_points || 0 }}
          <span class="d-block points-text-style">points</span>
        </span>
      </div>
      <div class="green-dot align-center" v-if="eligibleToRedeem">
        <Icon
          name="crownrewards"
          :color="'white'"
          :style="{
            height: '18px',
            width: '18px',
            'vertical-align': 'inherit',
            'padding-left': '2px',
          }"
        ></Icon>
      </div>
    </div>
    <span class="text-center">
      <p
        class="primary--text mb-0 pt-2"
        :class="$vuetify.breakpoint.smAndUp ? 'text-subtitle-2' : 'text-11'"
      >
        Redeem Points
      </p>
      <p
        :class="$vuetify.breakpoint.smAndUp ? 'text-11' : 'text-9'"
        class="mb-1 secondary--text"
        style="line-height: normal"
        v-if="nextTierPoints - total_points || 0 !== nextTierPoints"
      >
        Points Needed for<br />
        Next Reward Level: <br />
        {{ nextTierPoints - (total_points || 0) }}
      </p>
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Icon from "@/components/UI/Icon.vue";
export default {
  name: "PointsTab",
  computed: {
    ...mapState({
      total_points: (state) => state.store.info.points?.total_points,
    }),
    ...mapState({
      pointsOffers: (state) => state.store.info.points_offers,
    }),
    nextTierPoints() {
      let data = [...this.pointsOffers];
      data.sort((a, b) => a.points - b.points);

      const closestTier = data.find(
        (item) => item.points > (this.total_points || 0),
      );
      return closestTier?.points || this.total_points || 0;
    },
    eligibleToRedeem() {
      return this.pointsOffers.find((e) => e.points < this.total_points);
    },
  },
  components: { Icon },
};
</script>

<style scoped>
.dot-container {
  position: relative;
}
.dot {
  height: 85px;
  width: 85px;
  background-color: var(--v-primary-base);
  border-radius: 50%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scale-8 {
  transform: scale(0.8);
}
.green-dot {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: IDTSans, sans-serif;
  background-color: #41b029;
  color: white;
  border-radius: 50%;
  width: 23px;
  height: 23px;
  font-size: 12px;
  text-align: center;
  position: absolute;
  top: 10%;
  left: 85%;
  transform: translate(-50%, -50%);
}

.rewards-points {
  flex-grow: 0;
  font-family: IDTSans, sans-serif;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -0.32px;
  text-align: center;
  color: white;
}
.points-text-style {
  height: 15.3px;
  flex-grow: 0;
  font-family: IDTSans, sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: white;
}

.text-11 {
  font-size: 11px;
}
.text-9 {
  font-size: 9px;
}
</style>
